import React, { useState, useRef } from "react";
import axios from "axios";
import {
  CircularProgress,
  useTheme,
  Grid,
  Container,
  Paper,
  Hidden,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import Email from "@mui/icons-material/Email";
import Lock from "@mui/icons-material/Lock";
import LoginIcon from "@mui/icons-material/Login";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
//
import { Link } from "react-router-dom";
import { API_KEY } from "../config";

// Para movimentos e transicoes
import { motion } from "framer-motion";
// Para controlar e validar formulario
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastErro } from "../utils/utils";

const STRINGS = {
  titulo: "Precisa contratar ? 🤔",
  subtitulo:
    "Aqui é o lugar, autentique-se para encontrar os candidatos próximo a sua loja ou com o perfil que você deseja.",
  subtitulo2: "Escolha um candidato que atenda ao perfil da sua loja 🎯.",
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    height: "300px",
  },
};
// Schema de validacao dos daddos
const schema = yup.object().shape({
  email: yup.string().email().required(),
  senha: yup.string().min(6).required(),
});

const Raiz = () => {
  // Para referenciar o captcha invisivel
  const recaptchaRef = useRef();
  // Estado que controla a atividade do token
  const [token, setToken] = useState(null);
  return (
    <Container maxWidth="lg">
      <br />
      <Grid style={styles.container} container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormLogin
            token={token}
            setToken={setToken}
            recaptchaRef={recaptchaRef}
          />
        </Grid>
        <Hidden mdDown>
          <Grid item xs={6}>
            <Detail />
          </Grid>
        </Hidden>
      </Grid>
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={API_KEY} />
    </Container>
  );
};

// Formulairo para login
const FormLogin = ({ recaptchaRef, token, setToken }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // Estado para colocar formulario no aguardo
  const [aguardar, setAguardar] = useState(null);
  const [erro, setErro] = useState(null);
  const [verSenha, setVerSenha] = useState(false);

  // Pegando para ver se e mobile ou nao
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["md"] > window.innerWidth;

  // Funcao para enviar os dados para autenticacao
  const fn = async (val) => {
    setAguardar(true);
    setErro(null);

    let TOKEN = recaptchaRef.current.getValue();
    if (!token) {
      TOKEN = await recaptchaRef.current.executeAsync();
      setToken(TOKEN);
    } else {
      await recaptchaRef.current.reset();
      TOKEN = await recaptchaRef.current.executeAsync();
    }

    const formData = { ...val, captcha: TOKEN };

    // Enviando os dados
    axios
      .post("/", formData)
      .then((resp) => {
        // Alterando o usuario de rota
        window.location.href = "/curriculo";
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ToastErro(err.response.data.message);
        } else {
          ToastErro(String(err));
        }
      })
      .finally(() => {
        setAguardar(false);
      });
  };

  // Largura do botao
  const xsBtn = isMobile ? {} : { width: "50%", mx: "25%" };

  return (
    <Paper elevation={isMobile ? 0 : 4} style={styles.form}>
      <TextField
        type="email"
        fullWidth
        {...register("email")}
        label="Email"
        sx={{ mb: 2 }}
        placeholder="Seu e-mail"
        variant="outlined"
        error={!!errors && errors.email ? true : false}
        helperText={!!errors && errors.email && "Ex: email@gmail.com"}
        InputProps={{ startAdornment: <Email color="primary" /> }}
      />
      <TextField
        sx={{ mb: 2 }}
        type={verSenha ? "text" : "password"}
        fullWidth
        label="Senha"
        placeholder="Sua senha"
        variant="outlined"
        error={!!errors && errors.senha ? true : false}
        {...register("senha")}
        helperText={!!errors && errors.senha && "Senha de no mínimo 6 digitos"}
        InputProps={{
          startAdornment: <Lock color="primary" />,
          endAdornment: (
            <IconButton onClick={() => setVerSenha((state) => !state)}>
              {verSenha ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
          ),
        }}
      />
      {/* <Button sx={{ my: 2 }} color="info" variant="text" onClick={fnCadastro}>
        Não tem cadastro ? Inscreva-se
      </Button> */}
      <Link
        to="/esqueci_a_senha"
        style={{
          textDecoration: "none",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Button color="info">Esqueci a minha senha</Button>
      </Link>
      {erro && (
        <Typography color="error" align="center" variant="subtitle2">
          {erro}
        </Typography>
      )}
      <Button
        onClick={handleSubmit(fn)}
        disabled={aguardar}
        startIcon={aguardar ? <CircularProgress size={20} /> : <LoginIcon />}
        fullWidth
        sx={{ ...xsBtn, my: 1 }}
        color="primary"
        variant="contained"
      >
        Entrar
      </Button>
    </Paper>
  );
};
// Componente de detalhes
const Detail = () => (
  <motion.div
    initial={{ scale: 0.01 }}
    animate={{ scale: 1 }}
    transition={{ duration: 0.1, delay: 0.3 }}
  >
    <Typography align="" variant="h3">
      {STRINGS.titulo}
    </Typography>
    <Typography sx={{ mt: 2, opacity: ".5" }} variant="body1">
      {STRINGS.subtitulo}
    </Typography>
    <Typography sx={{ mt: 2 }} variant="h6">
      {STRINGS.subtitulo2}
    </Typography>
  </motion.div>
);
export default Raiz;
